import { mainSlider } from './mainSlider';
import { welluSlider } from './welluSlider';

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('[loading=lazy]').forEach((elm) => {
    elm.setAttribute('src', elm.dataset.src);
    elm.removeAttribute('data-src');
  });
  
  mainSlider();
  welluSlider();
});
